import { useTranslation } from 'react-i18next'

import { ConfirmDialog } from '~/components/common/ConfirmDialog'
import { convertAreaLabel } from '~/models/area'
import type { SingularDayRow } from '~/pages/AdminSingularDay/hooks/useListSingularDays'

type Props = {
  row: SingularDayRow
  isOpen: boolean
  isLoading: boolean
  errorMessage: string | undefined
  onConfirm: () => void
  onCancel: () => void
}

/**
 * 特異日削除確認ダイアログ (spec AC-009: 確認ダイアログを経由して論理削除)。
 * destructive variant (= negative ボタン) で表示。
 */
export const DeleteSingularDayModal = ({
  row,
  isOpen,
  isLoading,
  errorMessage,
  onConfirm,
  onCancel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  // spec AC-MSD-009: {エリア} は登録したエリアを「、」で並べ、 全エリア共通は「全エリア共通」とする。
  const areaText =
    row.areaCodes.length === 0
      ? t('page:adminSingularDay.table.areaAll')
      : row.areaCodes.map((c) => convertAreaLabel(c)).join('、')

  return (
    <ConfirmDialog
      body={
        errorMessage ??
        t('page:adminSingularDay.delete.confirmBody', {
          date: row.dateKey,
          area: areaText,
          name: row.name,
        })
      }
      confirmLabel={t('page:adminSingularDay.delete.confirmLabel')}
      destructive
      isLoading={isLoading}
      isOpen={isOpen}
      onCancel={onCancel}
      onConfirm={onConfirm}
      title={t('page:adminSingularDay.delete.confirmTitle')}
    />
  )
}
